exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setup-guide[data-v-19827f2b]{margin:24px 0;padding:20px;border:1px solid #e1e5eb;border-radius:8px;background:#fafbfc;color:#374151}.setup-guide h2[data-v-19827f2b]{margin:0 0 10px;font-size:17px}.setup-guide p[data-v-19827f2b]{font-size:13px;line-height:1.7;margin:10px 0}details[data-v-19827f2b]{padding:12px 0;border-top:1px solid #e1e5eb}summary[data-v-19827f2b]{cursor:pointer;font-weight:600}a[data-v-19827f2b],summary[data-v-19827f2b]{font-size:13px}a[data-v-19827f2b]{color:#44468f;text-decoration:underline}a[data-v-19827f2b]:focus-visible,summary[data-v-19827f2b]:focus-visible{outline:2px solid #44468f;outline-offset:3px}", ""]);

// exports
